import { Preview } from "../../../types/IAction";
import * as actions from "../../actions/externoDetalle";
import { GetExternoDetalle } from "../../reducers/externoDetalle";

export interface ExternoDetalleDispatcher {
  clearExternosDetalle: () => Promise<Preview<void>>;
  getExternoDetalleByIdPersona: (
    idPersona: number
  ) => Promise<Preview<GetExternoDetalle>>;
}

export const externoDetalleDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ExternoDetalleDispatcher = dispatch => ({
  clearExternosDetalle: () => dispatch(actions.clearExternosDetalle()),
  getExternoDetalleByIdPersona: (idPersona: number) =>
    dispatch(actions.getExternoDetalleByIdPersona(idPersona))
});
